export interface PrecioFinalInput {
  precioVenta?: number | null;
  calculaIva?: string | null;
  ivaCF?: number | null;
}

/** Precio final = precio neto + IVA C.F. si calculaIva = S. */
export function calcPrecioFinal(data: PrecioFinalInput): number | null {
  const rawPn = data.precioVenta;
  const precioNeto = rawPn != null ? Number(rawPn) : null;
  if (precioNeto == null || Number.isNaN(precioNeto)) return null;
  if (data.calculaIva === 'S') {
    const rawIva = data.ivaCF;
    const ivaCF = rawIva != null ? Number(rawIva) : 0;
    return Math.round(precioNeto * (1 + (Number.isNaN(ivaCF) ? 0 : ivaCF) / 100) * 100) / 100;
  }
  return Math.round(precioNeto * 100) / 100;
}

export function calcPrecioNetoDesdeCostoYMkp(
  costo: number | null | undefined,
  porcentajeMkp: number | null | undefined,
): number | null {
  if (costo == null || porcentajeMkp == null) return null;
  const c = Number(costo);
  const pct = Number(porcentajeMkp);
  if (Number.isNaN(c) || Number.isNaN(pct)) return null;
  return Math.round(c * (1 + pct / 100) * 10000) / 10000;
}

/** % MKP desde costo y precio neto mínimo: ((precio / costo) - 1) * 100 */
export function calcPorcentajeMkpDesdeCostoYPrecio(
  costo: number | null | undefined,
  precioNeto: number | null | undefined,
): number | null {
  if (costo == null || precioNeto == null) return null;
  const c = Number(costo);
  const p = Number(precioNeto);
  if (Number.isNaN(c) || Number.isNaN(p) || c <= 0) return null;
  return Math.round(((p / c) - 1) * 100 * 100) / 100;
}
